import styled, { css } from 'styled-components';
import { focusRing } from '@/app/components/search/styles/mixins.ts';

export const CheckboxStyled = styled.div<{ value: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  > label:focus-within {
    .check-icon-checkbox {
      border-radius: 2px;
      ${focusRing}
    }
    &:focus-visible {
      outline: none;
      box-shadow: none;
      overflow: visible;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

export const Input = styled.input`
  &:checked ~ * svg {
    rect {
      fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
      stroke: ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryDefault};
    }
  }

  &:focus-visible {
    svg {
      border-radius: 2px;
      ${focusRing}
    }
  }
`;
